<template>
    <div>
        <el-menu class="sub-menu" mode="horizontal" :default-active="subActiveRouter" router>
            <el-menu-item index="Push" :route="{name:'Push'}"><i class="el-icon-coin"></i>a股实时数据</el-menu-item>
            <el-menu-item index="Push1" :route="{name:'Push1'}"><i class="el-icon-data-analysis"></i>科创版实时数据</el-menu-item>
        </el-menu>

        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "MsgLayout",
        data() {
            return {
                subActiveRouter: ""
            }
        },
        mounted() {
            // 获取当前的所有路由
            this.subActiveRouter = this.$route.matched[2].name;
        }
    }
</script>

<style scoped>
    .sub-menu .el-menu-item {
        line-height: 40px;
        height: 40px;
        vertical-align: middle;
        font-size: 13px;
    }

    .sub-menu .el-menu-item i {
        margin-top: -3px;
    }
</style>
